import { http } from '../request'
import { normalizeListResponse } from './shared'

export interface BuildingDto {
  id: number
  name: string
  campusId?: number
  campusName?: string
  floors?: number
  type?: string
  status: number
  sort?: number
}

export const buildingApi = {
  async list(campusId?: number): Promise<BuildingDto[]> {
    const response = await http.get<BuildingDto[]>('/organization/buildings', campusId ? { campusId } : {})
    return normalizeListResponse<BuildingDto>(response.data)
  },
  async create(payload: Partial<BuildingDto>): Promise<BuildingDto> {
    const response = await http.post<BuildingDto>('/organization/buildings', payload)
    return response.data
  },
  async update(id: number, payload: Partial<BuildingDto>): Promise<BuildingDto> {
    const response = await http.put<BuildingDto>(`/organization/buildings/${id}`, payload)
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/organization/buildings/${id}`)
  }
}
